/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';

// Core
import { Button, Logo } from '@client/components';

// Resources
import TeamPhotos from '@/client/assets/img/team.png';

/*----------------------------------
- TYPES
----------------------------------*/


/*----------------------------------
- COMPONENT
----------------------------------*/
export default () => {
    return (
        <div class="col al-center pdv-2 bt-1">

            <div class="col w-a-4">
                <h2>Do you have any questions?</h2>

                <p class="reading">
                    Our team is dedicated to ensuring you have a seamless experience on our platform.
                </p>

                <img src={TeamPhotos} />

                <div class="col al-center">
                    <Button type="primary" link="https://wa.me/33764537599">
                        Contact us on Discord
                    </Button>
                </div>
            </div>

        </div>
    )
}